import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import authSlice from "./slices/authSlice";
import cartSlice from "./slices/cartSlice";
import contentSlice from "./slices/contentSlice";
import filterProductSlice from "./slices/filterProductSlice";

// children are reloaded from outlet-parents/me/ — not the source of truth when persisted
const authPersistConfig = {
  key: "auth",
  storage,
  blacklist: ["children", "childrenLoaded", "selectedCustomer", "switchingLocked"],
};

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["cart", "auth"],
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authSlice.reducer),
  content: contentSlice.reducer,
  cart: cartSlice.reducer,
  filterProduct: filterProductSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          "filterProduct/setFilter",
          "cart/setOrderDate",
          "cart/setSelectedItem",
          "cart/setItems",
          "cart/updateItem",
          "cart/setItemQuantity",
        ],
        ignoredActionPaths: [
          "filterProduct.products",
          "cart.orderDate",
          "cart.selectedItem",
          "cart.items",
        ],
        ignoredPaths: [
          "filterProduct.products",
          "cart.orderDate",
          "cart.selectedItem",
          "cart.items",
        ],
      },
    }),
});

export default store;
export const persistor = persistStore(store);
